module.exports = __webpack_public_path__ + "static/media/mem8YaGs126MiZpBA-UFW50bbck.6923b196.woff2";